"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "NovageSkincareAdvisorController", {
  enumerable: true,
  get: function () {
    return _containers.NovageSkincareAdvisorController;
  }
});
Object.defineProperty(exports, "OPEN_FOUNDATION_FINDER_HREF_ATTRIBUTE", {
  enumerable: true,
  get: function () {
    return _constants.OPEN_FOUNDATION_FINDER_HREF_ATTRIBUTE;
  }
});
Object.defineProperty(exports, "OPEN_SKIN_DIAGNOSIS_HREF_ATTRIBUTE", {
  enumerable: true,
  get: function () {
    return _constants.OPEN_SKIN_DIAGNOSIS_HREF_ATTRIBUTE;
  }
});
Object.defineProperty(exports, "OPEN_VIRTUAL_TRY_ON_HREF_ATTRIBUTE", {
  enumerable: true,
  get: function () {
    return _constants.OPEN_VIRTUAL_TRY_ON_HREF_ATTRIBUTE;
  }
});
Object.defineProperty(exports, "OPEN_VIRTUAL_TRY_ON_PDP_HREF_ATTRIBUTE", {
  enumerable: true,
  get: function () {
    return _constants.OPEN_VIRTUAL_TRY_ON_PDP_HREF_ATTRIBUTE;
  }
});
Object.defineProperty(exports, "defaultTranslations", {
  enumerable: true,
  get: function () {
    return _constants.defaultTranslations;
  }
});
Object.defineProperty(exports, "translationsNamespace", {
  enumerable: true,
  get: function () {
    return _constants.translationsNamespace;
  }
});
var _constants = require("./constants");
var _containers = require("./containers");
